import React from 'react';

const ImageCollage = () => {
  // Simplified collage that will definitely work
  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      width: '100%', 
      height: '100%', 
      backgroundColor: 'black',
      overflow: 'hidden'
    }}>
      {/* Base div for image grid */}
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        {/* Row 1 */}
        <div style={{ position: 'absolute', top: '0%', left: '0%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/20250326_Starlink_11-7_liftoff-SpaceX_small.jpeg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '0%', left: '20%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/winston-churchill-speech.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '0%', left: '40%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/url-56.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '0%', left: '60%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/us-military-history-1800.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '0%', left: '80%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/p034s1vq.jpg" alt="" style={imgStyle} />
        </div>

        {/* Row 2 */}
        <div style={{ position: 'absolute', top: '25%', left: '0%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/U.S._Army_firefight_in_Kunar.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '25%', left: '20%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/977778.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '25%', left: '40%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/Fleet_5_nations.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '25%', left: '60%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/CapitolBuilding_001_7406847_20230306 (1).jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '25%', left: '80%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/220605124156-25-queen-elizabeth-platinum-jubilee-0605.jpg" alt="" style={imgStyle} />
        </div>

        {/* Row 3 */}
        <div style={{ position: 'absolute', top: '50%', left: '0%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/2050529_1.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '50%', left: '20%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/NASA_ApolloLanderOnMom-scaled.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '50%', left: '40%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/Silicon-Gallery-3-RN2866m.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '50%', left: '60%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/0_ESM93VkK03-8c_Lv.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '50%', left: '80%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/37d612f0-7497-4af5-adfc-8549bc6c673a_703x460.jpg" alt="" style={imgStyle} />
        </div>

        {/* Row 4 */}
        <div style={{ position: 'absolute', top: '75%', left: '0%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/1469941346144.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '75%', left: '20%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/Douglas_MacArthur_lands_Leyte1 (1).jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '75%', left: '40%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/Air-defence-Raytheon-signs-1.2-billion-contract-to-provide-Patriot-system-to-Switzerland.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '75%', left: '60%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/Kennedy-1024x576.jpg" alt="" style={imgStyle} />
        </div>
        <div style={{ position: 'absolute', top: '75%', left: '80%', width: '20%', height: '25%' }}>
          <img src="./checkmatelabscollage/images.jpeg" alt="" style={imgStyle} />
        </div>
      </div>

      {/* Darkened overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        zIndex: 2
      }} />
    </div>
  );
};

// Common style for all images
const imgStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block'
};

export default ImageCollage; 